var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroups(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 23V20.5556C25 18.2775 23.4703 16.3634 21.4 15.8207M17.2 1.35537C18.9591 2.08062 20.2 3.83716 20.2 5.88889C20.2 7.94062 18.9591 9.69715 17.2 10.4224M19 23C19 20.7221 19 19.5831 18.6346 18.6847C18.1475 17.4867 17.213 16.535 16.0369 16.0388C15.1548 15.6667 14.0365 15.6667 11.8 15.6667H8.2C5.96348 15.6667 4.84522 15.6667 3.96312 16.0388C2.78698 16.535 1.85255 17.4867 1.36538 18.6847C1 19.5831 1 20.7221 1 23M14.8 5.88889C14.8 8.58895 12.651 10.7778 10 10.7778C7.34903 10.7778 5.2 8.58895 5.2 5.88889C5.2 3.18883 7.34903 1 10 1C12.651 1 14.8 3.18883 14.8 5.88889Z",
    stroke: "#F7C001",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroups);
export default __webpack_public_path__ + "static/media/groups.a729f89fcd0d1a7901bd5d6cd2be0270.svg";
export { ForwardRef as ReactComponent };